<app-entity-list
    [get-data]="getData()"
    [get-selected-data]="getSelectedData()"
    [rowData]="rowData()"
    [rowSelectedData]="rowSelectedData()"
    [rowClickBehaviour]="rowClickBehaviour()"
    [autoSizeStrategy]="autoSizeStrategy()"
    [columnDefs]="colDefs()"
    [features]="features()"
    [filter-options]="filterOptions()"
    [(filter-params)]="filterParams"
    [(refresh)]="refresh$"
    [navigationUrlTree]="navigationUrlTree()"
    [rowHeight]="RowHeight.TWO_LINE"
    (mouse-over-cell)="onCellMouseOver($event)"
    (click-cell)="onCellClicked($event)"
    (click-row)="onRowClicked($event)"
    (select-row)="onRowSelected($event)"
    (select-changed)="onSelectionChanged($event)"
>
    @if(features().viewTools.enabled){
        <div class="d-flex flex-row gap-2 align-items-center" ngProjectAs="tool-group">
            @if(features().createCompany.enabled){
                <app-company-new [(refresh)]="refresh$" (create)="onEntityCreated($event)"/>
            }
        </div>
    }

</app-entity-list>